<template>
  <TaskPage class="signup-later-page" no-back no-action>
    <template #title>Get started</template>
    <div class="task-content">
      <img src="@/assets/icons/green_check_circle_64.png" alt="Checkmark"/>
      <div>
        Great! You're signed up for the preview. We'll send you an email as soon as you're in.
      </div>
      <div class="link-section">
        <div>
          Meanwhile, check us out on social media, and feel free to ask any questions you have!
        </div>
        <div class="links">
          <a href="https://www.facebook.com/groups/1484810245417258"><img src="@/assets/logos/Facebook.png"/></a>
          <a href="https://discord.gg/mFkGM5fH7b"><img src="@/assets/logos/Discord.svg"/></a>
          <a href="https://x.com/treecrossing"><img src="@/assets/logos/X.png"/></a>
        </div>
      </div>
    </div>
  </TaskPage>
</template>

<style lang="scss" scoped>
.task-content {
  margin: 0 auto;
  max-width: 450px;
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  text-align: center;
}

.link-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.links {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;

  img {
    max-width: 35px;
    height: 30px;
    vertical-align: baseline;
  }
}
</style>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSignInStore } from '@webapp/auth/SignInStore'
import TaskPage from '@webapp/util/TaskPage.vue'

const signInStore = useSignInStore()
const router = useRouter()

onMounted(() => {
  if (!signInStore.subject) {
    router.replace('/signup')
  }
})

</script>
